// TODO enable eslint
/* eslint-disable react/sort-comp */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/no-array-index-key */
import React from "react"
import maxBy from "lodash/maxBy"
import styles from "./styles.css"

export default class TagModal extends React.Component {
  /* eslint react/no-unused-state: 0 */
  state = {
    isVisible: false,
    positions: 0,
  }

  toggleModal = () => {
    if (!this.state.isVisible) {
      this.setState({
        isVisible: !this.state.isVisible,
        positions: this.AddTagsPosition.getBoundingClientRect().top,
      })
    } else {
      this.setState({
        isVisible: !this.state.isVisible,
        positions: 0,
      })
    }
  }

  TagsWithModal = () => {
    let modalLeftPosition = 0
    let rowCount = 1
    let lastWidth = 0
    const MAX_WIDTH = maxBy(this.props.tags, `maxWidth`).maxWidth
    if (MAX_WIDTH > 500) {
      modalLeftPosition = 500
    } else {
      let countLeftMargin = 0
      this.props.tags.forEach(item => {
        if (countLeftMargin + item.maxWidth < 500) {
          countLeftMargin += item.maxWidth + 4
        }
      })
      if (countLeftMargin > 484) {
        modalLeftPosition = 516
      } else {
        modalLeftPosition = countLeftMargin + 20
      }
    }
    this.props.tags.forEach(item => {
      if (item.maxWidth > 495) {
        lastWidth += 495
      } else {
        lastWidth += item.maxWidth
      }
      if (lastWidth > modalLeftPosition) {
        if (item.maxWidth > 495) {
          lastWidth = 495
        } else {
          lastWidth = item.maxWidth
        }
        rowCount += 1
      }
    })
    if (rowCount > 5) {
      rowCount = 5
    }
    let modalTopPosition = -10
    if (
      this.state.positions + rowCount * 34 + 56 >
      document.getElementsByTagName(`body`)[0].offsetHeight - 20
    ) {
      if (rowCount === 5) {
        modalTopPosition = 222
      } else {
        modalTopPosition = rowCount * 34 + 56
      }
    } else {
      modalTopPosition = -10
    }
    return (
      <div
        className={styles.ModalContent}
        style={{
          marginLeft: `-`
            .concat(modalLeftPosition - this.props.modalLeftPosition)
            .concat(`px`),
          marginTop: `-`.concat(modalTopPosition).concat(`px`),
          maxWidth: modalLeftPosition,
          top:
            this.state.positions === 0
              ? this.AddTagsPosition.getBoundingClientRect().top + 30
              : this.state.positions + 30,
        }}
        ref={el => {
          this.instance = el
          return this.instance
        }}
      >
        {this.props.tags.map((field, index) => (
          <span key={index} className={styles.ModalTags}>
            {field.text}
          </span>
        ))}
      </div>
    )
  }

  // TODO - think about another way to scroll Modal Window
  // Here we count top for Modal Window when we scroll page
  scrollListener = () => {
    this.setState({
      positions: this.AddTagsPosition.getBoundingClientRect().top,
    })
  }

  componentDidMount() {
    window.addEventListener(`scroll`, this.scrollListener, false)
  }

  componentWillUnmount() {
    window.removeEventListener(`scroll`, this.scrollListener, false)
  }

  render() {
    return (
      <div>
        <div className={styles.ModalWindow}>
          <span
            className={styles.AddTags}
            style={
              this.state.isVisible
                ? { backgroundColor: `#e2e2e2` }
                : { backgroundColor: `#ffffff` }
            }
            onClick={() => this.toggleModal()}
            ref={el => {
              this.AddTagsPosition = el
              return this.AddTagsPosition
            }}
          >
            Ещё {this.props.tags.length}...
          </span>
          {this.state.isVisible && this.TagsWithModal()}
        </div>
        {this.state.isVisible && (
          <div className={styles.Overlay} onClick={() => this.toggleModal()} />
        )}
      </div>
    )
  }
}
